import { parseDesign } from "@/components/match/design-codec";
import { EMPTY_MATCH_DATA, incompleteCompanyConditionCount } from "@/components/match/match-design-rules";
import type { MatchData } from "@/components/match/match-design-types";

export type ListingSearchTarget = "PEOPLE" | "COMPANIES";
export function listingSearchTarget(data: unknown): ListingSearchTarget {
  return data && typeof data === "object" && "searchTarget" in data && data.searchTarget === "COMPANIES" ? "COMPANIES" : "PEOPLE";
}
export function companyRequirementsData(raw: unknown): MatchData {
  const parsed = parseDesign(raw);
  return { ...EMPTY_MATCH_DATA, companyConditions: parsed.companyConditions,
    unknownCompanyConditions: parsed.unknownCompanyConditions };
}
export function hasCompanyRequirements(data: MatchData): boolean {
  return !!data.companyConditions?.some((row) => row.active) && incompleteCompanyConditionCount(data) === 0;
}
